import { useRef } from 'react';
import { LocationOnIcon } from '@ui/icons/material/LocationOn';
import { PhoneIcon } from '@ui/icons/material/Phone';
import { EmailIcon } from '@ui/icons/material/Email';
import { AccessTimeIcon } from '@ui/icons/material/AccessTime';
import '../styles/contact-form.css';

export default function ContactForm() {
  const sectionRef = useRef<HTMLDivElement>(null);

  return (
    <section className="contact-form section" id="contact" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title fade-up">Liên hệ với chúng tôi</h2>

        <div className="contact-content">
          <div className="contact-info fade-up">
            <h3>Thông tin liên hệ</h3>
            
            <div className="info-item">
              <LocationOnIcon className="info-icon" />
              <div className="info-text">
                <h4>Địa chỉ</h4>
                <p>Số 179 Nguyễn Văn Cừ, Phường An Khánh, Quận Ninh Kiều, TP. Cần Thơ</p>
              </div>
            </div>

            <div className="info-item">
              <PhoneIcon className="info-icon" />
              <div className="info-text">
                <h4>Điện thoại</h4>
                <p>(0292) 3830 127 - (0292) 3830 128</p>
              </div>
            </div>

            <div className="info-item">
              <EmailIcon className="info-icon" />
              <div className="info-text">
                <h4>Email</h4>
                <p>contact@ctump.edu.vn</p>
              </div>
            </div>

            {/*<div className="info-item">
              <AccessTimeIcon className="info-icon" />
              <div className="info-text">
                <h4>Giờ làm việc</h4>
                <p>Thứ 2 - Thứ 6: 7:30 - 17:30</p>
                <p>Thứ 7: 7:30 - 12:00</p>
              </div>
            </div>*/}
          </div>

          <div className="contact-map fade-up">
            <iframe
              title="Can Tho University of Medicine and Pharmacy Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.1234567890123!2d105.77777!3d10.03333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sCan%20Tho%20University%20of%20Medicine%20and%20Pharmacy!5e0!3m2!1svi!2svn!4v1234567890"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}